var React = require('react');

function Cart2025 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M14.1366 4.96667H16.8667C17.4926 4.96667 18 5.47409 18 6.10001V16.8667C18 17.4926 17.4926 18 16.8667 18H2.13333C1.50741 18 1 17.4926 1 16.8667V6.10001C1 5.47409 1.50741 4.96667 2.13333 4.96667H4.8634H14.1366Z","stroke":"black","strokeWidth":"1.7","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M6.1001 7.8V4.08514C6.1001 3.26691 6.45831 2.48219 7.09593 1.90362C7.73356 1.32504 8.59836 1 9.5001 1C10.4018 1 11.2666 1.32504 11.9043 1.90362C12.5419 2.48219 12.9001 3.26691 12.9001 4.08514V7.8","stroke":"black","strokeWidth":"1.7","strokeLinejoin":"round","key":1})]);
}

Cart2025.defaultProps = {"width":"19","height":"19","viewBox":"0 0 19 19","fill":"none"};

module.exports = Cart2025;

Cart2025.default = Cart2025;
